module.exports = __webpack_public_path__ + "static/img/wealth_level_63.d433ea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_63.png
// module id = 6RTN
// module chunks = 0